
import { defineComponent } from 'vue';
import { Converter } from 'showdown';

const converter = new Converter();
export default defineComponent({
  props: {
    markdown: {
      type: String,
      default: '',
    },
  },
  computed: {
    markdownToHtml(): string {
      return converter.makeHtml(this.markdown);
    },
  },
});
